// extracted by mini-css-extract-plugin
module.exports = {"root":"u-link__2t6nXDtF","spin":"u-link_spin__2t6nXDtF"};